import { render } from "./tests.vue?vue&type=template&id=fa7ba7ec"
import script from "./tests.vue?vue&type=script&lang=js"
export * from "./tests.vue?vue&type=script&lang=js"

import "./tests.vue?vue&type=style&index=0&id=fa7ba7ec&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__